// extracted by mini-css-extract-plugin
export default {"Status":"TransactionStatus_Status__y4X5z"};